import { Component } from "react"
import { IOption } from "src/types"
import { ApiData, getApiDataPromise } from "../../models/ApiData"
import { Selector } from "../form/select"
import { ExchangeRate } from "./ExchangeRate"

interface State {
  data_list: object[]
  cryptoOptions: IOption[]
  selected_symbol: IOption | null
  loaded: boolean
}
export default class ExchangeFiatRates extends Component<{}, State> {
  state: State = {
    data_list: [{}],
    cryptoOptions: [],
    selected_symbol: null,
    loaded: false,
  }
  public onChangeCurrency = (option: IOption) => {
    this.loadSymbol(option)
    this.setState({
      selected_symbol: option,
    })
  }

  public componentDidMount(): void {
    getApiDataPromise({}, "exchange", "get_currencies").then(
      (res: { data: { crypto: { rate: string; code: string; name: string }[] } }) => {
        const cryptoOptionsList = Object.entries(res.data?.crypto ?? {}).map(([value, item]) => ({
          value,
          label: value,
          meta: item,
        }))
        this.setState({
          cryptoOptions: cryptoOptionsList,
        })
        this.loadSymbol({ label: "BTC", value: "BTC" })
      },
    )
  }

  private loadSymbol(option: IOption) {
    ApiData.exchangeApiRequest({ symbol: option.value }, "get_rates_crypto_symbol").then((result) => {
      if (result.success)
        this.setState({
          data_list: result.data,
          selected_symbol: option,
          loaded: true,
        })
    })
  }

  public render = () => {
    return (
      <>
        <div className="box box__currencies light">
          <div className="box__header d-md-flex align-items-center justify-content-between">
            <span className="box__title">Supported Fiat Currencies</span>
            <div className="price__currency float-lg-right">
              <Selector
                value={this.state.selected_symbol}
                options={this.state.cryptoOptions}
                onChange={this.onChangeCurrency}
                variant="text"
                lightTheme
              />
            </div>
          </div>
          <div className="box__wrapper">
            {this.state.loaded &&
              [this.state.data_list.find((e: any) => e.symbol === "EUR")].map(
                (e: any, index: number) =>
                  e.symbol !== "RUB" && (
                    <ExchangeRate
                      key={index}
                      from_cur={e.symbol ? e.symbol : ""}
                      from_cur_title={e.title}
                      to_cur={this.state.selected_symbol?.value ?? ""}
                      rate={e.rate}
                    />
                  ),
              )}
            <div className="box-row d-flex align-items-center">
              <div className="box-row__cur d-flex align-items-center" style={{ width: "calc(70% - 30px)" }}>
                <img src="/img/currency/usd-w.svg" alt="c$" className="assets-row__img" />
                <div>
                  <span className="box-row__name">USD</span>
                </div>
              </div>
              <div className="box-row__icon">
                <img src="/img/change.svg" alt="change" className="box-row__icon_change" />
              </div>

              <div className="box-row__cur" style={{ flexShrink: 2 }}>
                <span className="box-row__name">Coming soon</span>
              </div>
            </div>
            <div className="box-row d-flex align-items-center">
              <div className="box-row__cur d-flex align-items-center" style={{ width: "calc(70% - 30px)" }}>
                <img src="/img/currency/gbp-w.svg" alt="c$" className="assets-row__img" />
                <div>
                  <span className="box-row__name">GBP</span>
                </div>
              </div>
              <div className="box-row__icon">
                <img src="/img/change.svg" alt="change" className="box-row__icon_change" />
              </div>
              <div className="box-row__cur" style={{ flexShrink: 2 }}>
                <span className="box-row__name">Coming soon</span>
              </div>
            </div>
            <div className="box-row d-flex align-items-center">
              <div className="box-row__cur d-flex align-items-center" style={{ width: "calc(70% - 30px)" }}>
                <img src="/img/currency/c$-w.svg" alt="c$" className="assets-row__img" />
                <div>
                  <span className="box-row__name">CAD</span>
                </div>
              </div>
              <div className="box-row__icon">
                <img src="/img/change.svg" alt="change" className="box-row__icon_change" />
              </div>
              <div className="box-row__cur" style={{ flexShrink: 2 }}>
                <span className="box-row__name">Coming soon</span>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}
